type ImportFile = Pick<File, 'name' | 'size' | 'arrayBuffer' | 'text'>;
type Translate = (id: string, values?: Record<string, unknown>) => string;

interface ImportLimits { importBytes: number }

/** Share one limits request so an early file waits without reading bytes before the limit is known. */
export function importLimits<T extends ImportLimits>(load: () => Promise<T>): () => Promise<T | null> {
  let answer: Promise<T | null> | undefined;
  return () => (answer ??= load().catch(() => null));
}

/** Use the server's configured limit before allocating or decoding any file content. */
export async function readImportFile(file: ImportFile, importBytes: number | null, t: Translate): Promise<string> {
  if (importBytes === null || !Number.isSafeInteger(importBytes) || importBytes <= 0) {
    throw new Error(t('import.limitsUnavailable'));
  }
  if (file.size > importBytes) throw new Error(t('import.tooLarge', { bytes: importBytes }));
  return file.name.toLowerCase().endsWith('.csv')
    ? new TextDecoder('utf-8', { fatal: true }).decode(await file.arrayBuffer())
    : file.text();
}
